import { render, staticRenderFns } from "./pagination.component.vue?vue&type=template&id=1eea72af"
import script from "./pagination.component.vue?vue&type=script&lang=js"
export * from "./pagination.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports